var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarTodayOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 1a1 1 0 10-2 0v2H8V1a1 1 0 00-2 0v2H1a1 1 0 00-1 1v18a1 1 0 001 1h22a1 1 0 001-1V4a1 1 0 00-1-1h-5V1zm4 6V5H2v2h20zM2 9h20v12H2V9zm14.707 2.293a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 111.414-1.414L11 15.586l4.293-4.293a1 1 0 011.414 0z"
  })));
}
export default SvgCalendarTodayOutline;